export default __webpack_public_path__ + "static/onomondo-c8238f21d1a75503f37ef1c5b0a4267c.svg";